/**
 * Common helper function to extract permissions from profile data
 * Handles both vendor format (accessRole.permission) and factory format (permission)
 * @param profileData - The profile data from AuthService
 * @returns Array of permission objects with sideBarId and isView properties
 */
export function getPermissions(profileData: any): Array<{
  sideBarId: number;
  text?: string;
  path?: string;
  isView: boolean;
  isAdd?: boolean;
  isEdit?: boolean;
  isDelete?: boolean;
}> {
  // Handle vendor format: accessRole.permission
  if (profileData?.accessRole?.permission && profileData.accessRole.permission.length > 0) {
    return profileData.accessRole.permission;
  }

  // Handle factory format: permission (direct array)
  if (profileData?.permission && profileData.permission.length > 0) {
    return profileData.permission;
  }

  return [];
}
